// "#171": the task a call was about (set when the call is started from a task).
export default function TaskBadge({ call }) {
  if (call.task_no == null) return null;
  return (
    <span
      className="mono text-xs font-bold px-1.5 py-0.5 rounded bg-orange-50 text-[#FF5000] align-middle whitespace-nowrap"
      title={call.task_title || "Task"}
      data-testid={`call-task-${call.id}`}
    >
      #{call.task_no}
    </span>
  );
}
